import React from "react";

import blocking_mainenance_img from "../../assets/img/blocking-maintenance.png";
import Translations from "../../services/translation";

const BlockingMaintenance = () => (
    <div className="blocking-maintenance-container">
        <div>
            <div className="blocking-maintenance-heading">
                {Translations["keys"][Translations.activeLang]["BLOCKING_MAINTENANCE_WARNING_HEADING"]}
            </div>
            <div className="blocking-maintenance-description">
                <p>
                    {Translations["keys"][Translations.activeLang]["BLOCKING_MAINTENANCE_WARNING_DESCRIPTION"]}
                </p>
            </div>
        </div>
        <img className="blocking-maintenance-img" src={blocking_mainenance_img} alt="ongoing-maintenance"/>
    </div>
);

export default BlockingMaintenance;
